import { option } from 'fp-ts';
import { createContext, useContext } from 'react';
import { Catalog, CatalogFieldDetails } from 'modules/domains/catalog';
import { noop, noopOption } from 'utils/noop';

export type CatalogContextState = {
  catalog: option.Option<Catalog>;
  change: (value: option.Option<Catalog>) => void;
  catalogFieldDetails: option.Option<CatalogFieldDetails>;
  changeFieldDetails: (value: option.Option<CatalogFieldDetails>) => void;
  hasCatalogError: boolean;
  updateCatalogError: () => void;
  hasCatalogFieldError: boolean;
  updateCatalogFieldError: () => void;
};

export const defaultState = {
  catalog: option.none,
  change: noopOption,
  catalogFieldDetails: option.none,
  changeFieldDetails: noopOption,
  hasCatalogError: false,
  updateCatalogError: noop,
  hasCatalogFieldError: false,
  updateCatalogFieldError: noop,
};

export const CatalogContext = createContext<CatalogContextState>(defaultState);

export const useCatalogContext = () => useContext(CatalogContext);
